export default __webpack_public_path__ + "static/media/orange_play.e1457bb5.svg";